import React from 'react';
import Axios from 'axios';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Auth from '../../../../modules/Auth';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon as FontAwesome } from '@fortawesome/react-fontawesome';

class LogoutModal extends React.Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    hide: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.submitButton = React.createRef();

    this.state = {
      submitting: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { show } = this.props;

    if (!prevProps.show && show) {
      this.submitButton.current.focus();
    }
  }

  onSubmit(e) {
    e.preventDefault();

    const { history, hide } = this.props;

    this.setState({
      submitting: true,
    });

    Axios.post('/auth/logout').then(() => {
      hide();

      Auth.clear();

      history.push('/auth/login', {
        alert: {
          success: 'You are now logged out.',
        },
      });
    });
  }

  render() {
    const { show, hide } = this.props;
    const { submitting } = this.state;

    return (
      <Modal show={show} onHide={hide} centered>
        <Modal.Header onHide={hide} closeButton>
          <Modal.Title>
            Logout
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-0">
            Are you sure you want to continue?
          </p>
        </Modal.Body>

        <Modal.Footer bsPrefix="modal-footer justify-content-start">
          <button className="btn btn-danger" onClick={this.onSubmit} ref={this.submitButton} disabled={submitting}>
            {submitting ? <FontAwesome icon="circle-notch" spin /> : 'Confirm'}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

}

export default withRouter(LogoutModal);
